import "./setupThirdPartyScriptErrorGuards";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/fonts.css";
import "./index.css";

const setupProductionInspectGuards = () => {
  const inspectGuardEnv = process.env.REACT_APP_BLOCK_INSPECT;
    const shouldBlockInspect =
      inspectGuardEnv === "true" || (inspectGuardEnv !== "false");

  if (!shouldBlockInspect) return;

  // Block context menu to discourage quick inspect access.
  window.addEventListener("contextmenu", (event) => {
    event.preventDefault();
  });

  // Block common keyboard shortcuts used to open browser devtools/view-source.
  window.addEventListener("keydown", (event) => {
    const key = event.key?.toLowerCase();
    const isCtrlShift =
      (event.ctrlKey || event.metaKey) && event.shiftKey && (key === "i" || key === "j" || key === "c");
    const isF12 = key === "f12";
    const isViewSource = (event.ctrlKey || event.metaKey) && key === "u";

    if (isCtrlShift || isF12 || isViewSource) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
};

setupProductionInspectGuards();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
